var Tipo_garantiaComponent = /** @class */ (function () {
    function Tipo_garantiaComponent() {
        this.rows = [];
        this.garantia = { "DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA": false, "COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA": false };
        if (!JSON.parse(localStorage.getItem("tipo_garantia"))) {
            localStorage.setItem("tipo_garantia", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_garantia"));
            this.garantia = {
                "DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA": this.rows[0] ? this.rows[0].garantia['DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA'] : false,
                "COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA": this.rows[0] ? this.rows[0].garantia['COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA'] : false,
            };
        }
    }
    Tipo_garantiaComponent.prototype.add_tipo_garantia = function () {
        localStorage.setItem("tipo_garantia", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_garantia");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            garantia: this.garantia
        });
        localStorage.setItem("tipo_garantia", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_garantia")));
    };
    Tipo_garantiaComponent.prototype.delete_tipo_garantia = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_garantia", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_garantiaComponent;
}());
export { Tipo_garantiaComponent };
